import { useState, type FormEvent } from 'react'
import { Navigate, useNavigate, useSearchParams } from 'react-router'
import { useAuth } from '../auth/AuthProvider'
import { AuthCard } from '../components/AuthCard'

export function LoginScreen() {
	const { user, signIn } = useAuth()
	const navigate = useNavigate()
	const [params] = useSearchParams()
	const next = params.get('next')?.startsWith('/') ? params.get('next')! : '/'
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState<string | null>(null)
	const [busy, setBusy] = useState(false)

	if (user) return <Navigate to={next} replace />

	async function submit(e: FormEvent) {
		e.preventDefault()
		setBusy(true)
		setError(null)
		try {
			await signIn(email, password)
			navigate(next, { replace: true })
		} catch (err) {
			setError((err as Error).message)
		} finally {
			setBusy(false)
		}
	}

	return (
		<AuthCard title="Sign in" subtitle="App Store rankings, ratings and reviews.">
			<form className="form" onSubmit={submit}>
				<label className="field">
					Email
					<input
						type="email"
						autoComplete="username"
						required
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</label>
				<label className="field">
					Password
					<input
						type="password"
						autoComplete="current-password"
						required
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
				</label>
				{error && (
					<p className="error small" role="alert">
						{error}
					</p>
				)}
				<button className="primary" type="submit" disabled={busy}>
					{busy ? 'Signing in…' : 'Sign in'}
				</button>
			</form>
		</AuthCard>
	)
}
